let sdkReady

export function loadYouTubeSDK() {
  if (window.YT?.Player) return Promise.resolve()
  if (sdkReady) return sdkReady

  sdkReady = new Promise((resolve, reject) => {
    const previousCallback = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      resolve()
      if (previousCallback) previousCallback()
    }

    let script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]')
    if (!script) {
      script = document.createElement("script")
      script.src = "https://www.youtube.com/iframe_api"
      document.head.append(script)
    }
    script.addEventListener("error", () => {
      sdkReady = null
      script.remove()
      reject(new Error("YouTube SDK failed to load"))
    }, {once: true})
  })
  return sdkReady
}
